import type { Student as StudentData } from '@mathflat/domain/Student'
import { makeObservable, observable } from 'mobx'

import { EMPTY_STRING_ID } from '@/constant/common'
import { STUDENT_EDIT_EXEMPTION } from '@/constant/studentEditExemption'

import { DTO } from '../DTO'
import { SchoolGrade } from './SchoolGrade'
import type { Student } from './Student'

/***
 * 학생 상세 정보
 * @see StudentController
 ***/
export class StudentDetail extends DTO {
  id = EMPTY_STRING_ID
  loginId = ''
  name = ''
  attendanceCode = ''

  schoolGrade: {
    grade: 1 | 2 | 3 | 4 | 5 | 6
    schoolType: StudentData['schoolType']
  } = {
    grade: 1,
    schoolType: 'ELEMENTARY',
  }
  schoolName = ''
  email = ''
  address = ''
  phone = ''
  parentPhone = ''
  homePhone = ''
  memo = ''
  status: StudentData['status'] = 'ACTIVE'
  parent = { id: '', loginId: '', phone: '' }
  siblings: StudentData['siblings'] = []

  startDate: StudentData['startDate'] = null
  birthDate: StudentData['birthDate'] = null
  isVirtual = false // 가상학생여부

  allowedServiceTypes: StudentData['allowedServiceTypes'] = []
  restrictionExemptions: StudentData['restrictionExemptions'] = []

  get isSchoolTypeEditableWhenReadOnly() {
    return this.restrictionExemptions.includes(STUDENT_EDIT_EXEMPTION.SCHOOL_TYPE)
  }

  get isGradeEditableWhenReadOnly() {
    return this.restrictionExemptions.includes(STUDENT_EDIT_EXEMPTION.GRADE)
  }

  get isEnglishflatAllowed() {
    return this.allowedServiceTypes.includes('ENGLISHFLAT')
  }

  get isScienceflatAllowed() {
    return this.allowedServiceTypes.includes('SCIENCEFLAT')
  }

  constructor({
    schoolType,
    grade,
    memo,
    ...data
  }: Partial<StudentData & Pick<Student, 'isVirtual'>> = {}) {
    super()
    if (data) {
      this.updateExceptNullable<StudentDetail>(data, {
        schoolGrade: new SchoolGrade({ schoolType, grade }),
        memo: memo ?? undefined,
      })
    }
    makeObservable(this, {
      attendanceCode: observable,
      isVirtual: observable,
    })
  }
}
